import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "react-quill/dist/quill.snow.css";

// import { AuthProvider } from "./contexts/AuthContext";

//CHANGE WHEN ENV CHANGES TO PRODUCTION OR SOMETHING OTHER

window.process = {
  env: {
    NODE_ENV: "development", // or 'production'
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
